<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
  <Pagesubtitle subTitle="View your responses and online reviews.">
  </Pagesubtitle>
  <div class="af">   
  <vs-tabs v-model="currentTab" :key="$store.state.dash.currentMultiLocationI === false ? 'one' : 'tab' + String($store.state.dash.currentMultiLocationI) ">
  <vs-tab label="Survey Feedback" id="list" class="nofilterimags p-0">
    <div class="tab-text py-5">      
      <div class="ais-InstantSearch" id="algolia-instant-search-demo">
        
        <div class="algolia-header mb-4">
            <div class="flex md:items-end items-center justify-between flex-wrap">
                <!-- TOGGLE SIDEBAR BUTTON -->
                <vs-button v-if="!$store.state.dash.viewData.feedbackEmpty" type="border" class="w-full lg:hidden cursor-pointer"
                @click.stop="toggleFilterSidebar">{{ isFilterSidebarActive ? '< Filter' : 'Filter >' }} </vs-button>
            </div>
        </div>

        <div class="ais-SearchBox mb-4" v-if="filterableQuestions.length > 0">
                <div class="relative mb-4">
                  <v-select placeholder="View by question..." class="w-full bg-white ptlargerselect" size="large" :searchable="false" :options="filterableQuestions" label="questionText" :reduce="question => question.questionID" v-model="selectedQuestion"/>
                    <div v-if="currentSelectedQuestionData">
                    <h6 class="font-medium flex items-center text-light my-4 mt-6">BROWSE BY ANSWERS<vx-tooltip class="ml-1 inline-block" position="left" text="View responses with specific answers for this question.">
                      <small class="flex cursor-pointer">
                        <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4 text-light"></feather-icon>
                        </small>
                      </vx-tooltip>                    
                    </h6>
                    <div class="ais-RefinementList mb-6">
                        <ul class="flex justify-left">
                          <!---->                                                    
                          <li :key="option.text" class="mr-3 flex items-center justify-between" v-for="option in currentSelectedQuestionData.answerOptions">
                            <vs-checkbox :id="option.text" :vs-value="option.text" class="ml-0" v-model="showOnlyAnswers">{{option.text}}</vs-checkbox>
                          </li>                                                  
                        </ul>
                    </div>  
                    </div>  
                </div>
          </div >

        <div id="fb-content-container" class="relative clearfix minfilterh" ref="filterswrap">
            <!---->

            <vs-sidebar
                class="items-no-padding vs-sidebar-rounded float-right previewtransition"
                ref="filters"
                :class="{'dsabled': $store.state.dash.viewState.loadingFeedback}"
                parent="#fb-content-container"
                :click-not-close="clickNotClose"
                :hidden-background="true"
                v-model="isFilterSidebarActive">                                       

              <i @click="toggleFilterSidebar" class="lg:hidden  vs-icon pt_absolute_right notranslate icon-scale vs-dialog-cancel vs-dialog-cancel--icon notranslate material-icons null">close</i>

              <div class="vs-sidebar--items">     
                                                
                <div class="p-6 filter-container">
                                

                <div v-if="showPagination">
                 <Pagination/>
                 <vs-button class="w-full my-3" type="border" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshFeedback">Refresh responses</vs-button>
                <vs-divider/>
                

                </div>
                  <div>
                    <h6 class="font-medium text-light mb-2">DATE</h6>
                  <div>  
                    <p class="my-1 flex justify-between"><span>From</span><span class="text-light">To</span></p>
                    <date-picker :editable="false" class="w-full cursor-pointer" v-model="period" valueType="timestamp" range placeholder="All"></date-picker>
                  </div>
                  <vs-divider/>
                    <div>
                    <h6 class="font-medium text-light mb-4">RATING</h6>
                    <div class="ais-RefinementList">
                        <ul>
                          <!---->                          
                          <li class="mb-2 flex items-center justify-between">
                            <vs-checkbox class="ml-0" v-model="showPositive" @click="() => {}">Positive</vs-checkbox>
                          </li>
                          <li class="mb-2 flex items-center justify-between">
                            <vs-checkbox class="ml-0" v-model="showNeutral" @click="() => {}">Neutral</vs-checkbox>
                          </li>
                          <li class="mb-2 flex items-center justify-between">
                            <vs-checkbox class="ml-0" v-model="showNegative" @click="() => {}">Negative</vs-checkbox>
                          </li>
                          <vs-divider/>
                          <li class="mb-2 flex items-center justify-between">
                            <vs-checkbox class="ml-0" v-model="showNoRating" @click="() => {}">No rating</vs-checkbox>
                          </li>                          
                        </ul>
                    </div>                   
                    <vs-divider/>
                    </div>                        

                    <div v-if="!selectedQuestion">
                    <h6 class="font-medium text-light  mb-2">TEXT</h6>
                    <p class="text-sm mb-2">Filter by word or phrase</p>
                    <vs-input placeholder="Enter word or phrase" v-model="textFilter" class="w-full" size="large"/>
                    <vs-divider/>
                    </div>
                    <ul>
                      <!---->
                      <li class="mb-2 flex items-center justify-between">
                        <vs-checkbox class="ml-0" v-model="showSpam" @click="() => {}">Archived Only</vs-checkbox>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>                            
            </vs-sidebar>

          <div :class="{'sidebar-spacer-with-margin': clickNotClose}">                      

        <div class="text-center py-10" v-if="$store.state.dash.viewState.loadingFeedback">
        <div class="w-12 h-12 pt_loading inline-block"></div>
        </div>
        <div class="ais-Hits responsive relative lg:pr-3" v-else>

          <!-- FEEDBACK HAS BEEN FETCHED BUT IS EMPTY -->
          <div v-if="$store.state.dash.viewData.feedbackEmpty">
          <div class="mx-0 top-sm md:top-md lg:-ml-halffilterbar ptnoresponses text-center">
            <p class="text-primary font-semibold text-2xl my-6">No responses yet.</p>
            <img src="@/assets/images/misc/smile.png" class="w-full block mx-auto"/>
            <p class="mb-6 text-xl px-6 font-medium">Get your customers to visit your {{ $store.getters['dash/isAgencyClientParentEID'] ? 'survey link' : 'feedback link' }}!</p>
          </div>
          <div class="items-list-view mb-5" :class="{'spamtimehover' : clickNotClose}" v-for="item in [1,2,3,4,5,6,7]">
            <div class="vx-card list-view-item overflow-hidden">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-row item-details no-gutter">
                  <div class="vx-col sm:w-1/12 w-full item-img-container bg-white flex items-center justify-center cursor-pointer">
                    <span class="text-3xl font-semibold text-success">
                      <div class="hidden md:block ptlowfi block"></div>
                    </span>
                  </div>
                  <div class="vx-col w-full sm:w-8/12">
                    <div class="p-4">
                      <div class="ptlowfi w-4/12 mb-2"></div>
                      <div class="ptlowfi w-9/12"></div>
                    </div>
                  </div>
                  <div class="vx-col hidden md:block sm:w-3/12 w-full flex items-center">
                    <div class="p-4 flex flex-col w-full items-center">
                      <div class=" ptlowfi w-5/12 mx-auto"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-card__code-container collapsed" style="max-height: 0px; display: none;">
              <div class="code-content"><pre class="language-markup"><code class="language-markup"></code></pre></div>
            </div>
          </div>
          </div>
          </div>



          <!-- FEEDBACK HAS BEEN FETCHED AND HAS 1+ -->
          <div v-else>

          <div v-if="$store.state.dash.viewData.viewFeedback.length > 0 || $store.state.dash.viewData.viewQuestionResults">

          <p class="flex px-1 pb-4 justify-between" v-if="!selectedQuestion">
            <span><span class="text-sm">showing </span><span class="font-medium">{{$store.getters['dash/collectionInfo'].count}} response{{$store.getters['dash/collectionInfo'].count === 1 ? '':'s'}}</span></span>
            <span><span class="text-sm hidden md:inline">showing </span> <span class="font-medium">{{formatDate(new Date($store.getters['dash/collectionInfo'].toTimeS * 1000))}} to {{formatDate(new Date($store.getters['dash/collectionInfo'].fromTimeS * 1000))}}</span></span>
          </p>

          <div v-if="$store.state.dash.viewData.viewQuestionResults && showOnlyAnswers.length === 0">                        
            
            <h4 class="mt-10 mb-5">QUANTIFIED SUMMARY</h4>
            
            <div class="vx-row">
            <div class="vx-col w-full mb-5">
              
              <vx-card v-if="$store.state.dash.viewData.viewQuestionResults.total > 0" :subtitle="String($store.state.dash.viewData.viewQuestionResults.total) + ' Responses'" subtitle-color="light">
                <h4 class="mb-2">{{ currentSelectedQuestionData.questionText }}</h4>
                <div class="mb-6 overflow-auto">
                  <span class="float-left"></span>
                  <span class="float-right"></span>
                </div>

                  <div v-for="(value, i) in $store.state.dash.viewData.viewQuestionResults.results" :key="String(i)" class="clear-both mt-4">
                      <div class="flex justify-between">
                          <div class="flex flex-col text-lg">
                              <span class="mb-1">{{ value.name }}</span>
                          </div>
                          <div class="flex flex-col text-right text-lg">
                              <span class="text-light">{{ value.numberOfVotes }} ({{value.percentage}}%)</span>
                          </div>
                      </div>
                      <vs-progress height="10" :percent="value.percentage"></vs-progress>
                  </div>
              </vx-card>
              <NoFilteredResponses v-else/>

            </div>
          </div>          
          </div>          
          
          <div>
          <div class="items-list-view mb-7" :class="{'spamtimehover' : clickNotClose}" v-for="(session, i) in $store.state.dash.viewData.viewFeedback">            
            <div class="vx-card list-view-item overflow-hidden py-4 sm:py-0">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="vx-row item-details no-gutter relative">
                                   

                  <div class="vx-col w-full sm:w-10/12 p-3 md:p-8 fbbl">
               
                    <div v-for="(response,i) in session.journeyFeedback" class="my-1">
                      
                    <div v-if="
                      response.answer !== null &&
                      response.answer !== false && 
                      response.answer !== ''
                    ">
                      <div v-if="
                        response.questionID !== 'CONTACT' && 
                        response.type !== 'ratingq' && 
                        response.type !== 'shareq' &&
                        response.type !== 'welcome' &&
                        response.type !== 'thankyou'                         
                        ">
                        <p class="text-base text-light" v-if="response.type !== 'testimonial'">{{ response.ask }}</p>
                        
                        <p class="item-name font-medium text-black text-xl py-1 shadow-transition" >
                          <Showcase  class="ml-2 -mt-2 float-right" v-if="
                              response.type === 'openq'" 
                              :payload="{
                                data: { 
                                  platform: 'feedback', 
                                  i:response.i, 
                                  sessionID: session.sessionID
                                }, 
                                method: toggleShowcaseFeedback 
                                }" 
                              :showcasedStatus="$store.state.dash.viewData.currentShowcasedIDs.find(sItem => sItem.id === `${session.sessionID}_${response.i}`)" 
                          />

                          
                          <span class="block whitespace-pre-wrap" v-if="response.type === 'openq' && response.answer.textAnswer">{{ response.answer.textAnswer }}</span>
                          
                          <div class="video mt-2 mb-5" v-if="response.type === 'openq' && response.answer.videoURLAnswer && response.answer.streamUID">
                              <HLSVideoPlayer :src="response.answer.videoURLAnswer" :options="{
                                controls: true,
                                autoplay: false,
                                preload: 'auto',
                              }"/>
                              <vs-button type="border" size="small" class="mt-1" @click="downloadVideo(response.answer.streamUID)" icon-pack="feather" icon="icon-download" icon-after></vs-button>
                              <img class="invisible" style="height: 0px !important" :src="`https://customer-n548bbvvl783tp8n.cloudflarestream.com/${response.answer.streamUID}/thumbnails/thumbnail.gif?time=1s&height=500&duration=4s`"/>
                              <img class="invisible" style="height: 0px !important"  :src="`https://customer-n548bbvvl783tp8n.cloudflarestream.com/${response.answer.streamUID}/thumbnails/thumbnail.jpg?time=0s&height=500`"/>
                          </div>



                          <span v-if=" response.type !== 'openq' && response.type!== 'testimonial' && Array.isArray(response.answer) ">
                            {{ response.answer.join(', ') }}
                          </span>
                          <span v-if=" response.type !== 'openq' && response.type!== 'testimonial' && !Array.isArray(response.answer) ">
                            {{ response.answer }}
                          </span>
                          <span class="block testo bggray" v-if="response.type === 'testimonial'">
                            <Showcase class="ml-2 -mt-2 float-right" 
                            :payload="{
                              data: { 
                                platform: 'testimonial', 
                                i:response.i, 
                                sessionID: session.sessionID
                              }, 
                              method: toggleShowcaseFeedback 
                              }" 
                            :showcasedStatus="$store.state.dash.viewData.currentShowcasedIDs.find(sItem => sItem.id === `${session.sessionID}_${response.i}`)" 
                            />
                            <div class="testinfo mb-4">
                              
                              <div>
                              <div :style="{
                                backgroundColor: pmyColorLight,
                                borderColor: pmyColor,
                                color: pmyColor
                              }" class="pp empty" v-if="!response.answer.profilePicture">
                                  <span>{{ getReviewerAcronym(response.answer.name) }} </span>
                                  <span class="changePP" @click="intentUploadPic('pp', session.sessionID, response)">
                                    <feather-icon icon="UploadIcon" svgClasses="w-6 h-6 text-white"></feather-icon>
                                  </span>
                              </div>
                              <div class="pp" v-else>
                                <img  :src="response.answer.profilePicture"/>
                                <span class="changePP"  @click="intentUploadPic('pp', session.sessionID, response)">
                                    <feather-icon icon="UploadIcon" svgClasses="w-6 h-6 text-white"></feather-icon>
                                </span>
                              </div> 
                              </div>                             

                              <div>
                                <p class="font-semibold text-base">{{ response.answer.name }}</p>                                
                                <p v-if="response.answer.company" class="text-sm text-light">{{ response.answer.company }} <span v-if="response.answer.jobTitle"> {{ response.answer.company ? '|' : '' }} {{ response.answer.jobTitle }}</span></p>
                              </div>                              

                            </div>

                            <p class="testtxt">                              
                              <span class="block whitespace-pre-wrap font-medium text-black text-xl">{{ response.answer.textAnswer }}</span>
                            </p>      
                            

                            <div class="video" v-if="response.answer.videoURLAnswer && response.answer.streamUID">
                              <HLSVideoPlayer :src="response.answer.videoURLAnswer" :options="{
                                controls: true,
                                autoplay: false,
                                preload: 'auto',
                              }"/>
                              <vs-button type="border" size="small" class="mt-1" @click="downloadVideo(response.answer.streamUID)" icon-pack="feather" icon="icon-download" icon-after></vs-button>
                              <img class="invisible" style="height: 0px !important" :src="`https://customer-n548bbvvl783tp8n.cloudflarestream.com/${response.answer.streamUID}/thumbnails/thumbnail.gif?time=1s&height=500&duration=4s`"/>
                              <img class="invisible" style="height: 0px !important"  :src="`https://customer-n548bbvvl783tp8n.cloudflarestream.com/${response.answer.streamUID}/thumbnails/thumbnail.jpg?time=0s&height=500`"/>
                            </div>

                            <div class="flex justify-end">
                              <vs-button icon-pack="feather" @click="intentEditTesto(session.sessionID, response)" icon="icon-edit" size="small" type="border"></vs-button>
                            </div>

                          </span>

                        </p>

                      </div>

                      <div v-if="
                        response.questionID === 'CONTACT'                   
                        ">
                        <p class="text-base text-light mt-4" v-if="response.type !== 'testimonial'">{{ response.ask }}</p>
                        <div class="flex items-center">
                        <feather-icon icon="UserIcon" svgClasses="stroke-current text-primary w-5 h-5 mb-1 mr-1" />
                        <span class="font-medium my-3" v-html="renderContactDetailText(response.answer)"></span>
                        </div>
                      </div>
                    </div>


                    </div>
                    <div v-if="session.inviteSentToEmail || session.inviteSentToName || session.inviteSentToNumber">
                      <vs-divider class="my-3"/>
                      <span v-if="session.inviteSentToName"><feather-icon icon="UserIcon" svgClasses="stroke-current text-primary w-5 h-5 mr-1 relative" style="bottom: -0.2rem;"/><span class="font-medium">{{ session.inviteSentToName }} </span> </span>
                      <span v-if="session.inviteSentToEmail">| <span class="font-medium">
                        <a :href="`mailto:${session.inviteSentToEmail}?subject=Response%20to%20your%20feedback&body=Hi%20${encodeURIComponent(session.inviteSentToName + ',')}`">{{ session.inviteSentToEmail }}</a>
                      </span> </span>
                      <span v-if="session.inviteSentToNumber">| <span class="font-medium">{{ session.inviteSentToNumber }}</span> </span>
                    </div>
                    <div v-if="session.reference || session.orderReference">
                      <vs-divider class="my-3"/>
                      <span v-if="session.reference" class="mr-6">Reference: <span class="font-medium">{{session.reference}}</span></span><span class="inline-block" v-if="session.orderReference">Order: <span class="font-medium">{{ session.orderReference }}</span></span>
                    </div>
                  </div>
                                   
                  <div class="vx-col sm:w-2/12 w-full flex sessionsidepanel items-center sm:border bggray">                    
                    <div class="p-4 flex flex-col w-full items-center">
                      
                      <div class="w-16  text-center">
                        <span v-if="session.ratingType === 'nps' && !session.noRating" class="font-bold" 
                      :class="{
                        'text-danger': session.rating < 7, 
                        'text-success': session.rating > 8, 
                        'text-warning': session.rating < 9 && session.rating > 6, 
                        'text-3xl' : session.rating !== false, 
                        'text-base': session.rating === false
                        }">
                        {{ session.rating}}
                      </span>
                      
                       <div v-if="session.ratingType === 'star' && !session.noRating" class="w-full starratingwrap font-bold" 
                      :class="{
                      'text-danger': session.rating < 3, 
                      'text-success': session.rating > 3.9, 
                      'text-warning': session.rating < 4 && session.rating > 2.9
                      }">
                        <span class="text-3xl">{{ session.rating }}</span>
                        <Star class="w-16 h-16 vfbstar w-full"/>
                      </div>

                      <span v-if="session.ratingType === 'csat' && !session.noRating" class="font-bold" 
                      :class="{
                      'text-danger': session.rating < 3, 
                      'text-success': session.rating > 3.9, 
                      'text-warning': session.rating < 4 && session.rating > 2.9
                      }">
                        <Component class="w-10 h-10" :is="`CSAT${session.rating}`"/>                        
                      </span>
                      </div>

                      <p class="text-sm my-2 text-light">{{ session.inviteSentToEmail ? 'Email invite' : (session.inviteSentToNumber ? 'Text invite' : ( session.isFromWeb  ? 'From website' : /*public feedback link*/ ''))}}</p>
                      <span class="text-sm font-semibold ml-2 spamtimetimehover p-3" :class="{'mb-2' : !clickNotClose}">{{ timeSince(session.sessionStartTime).timeAgo === '' ? 'Just now' : timeSince(session.sessionStartTime).timeAgo }}</span>
                      <div class="absolute top-0 right-0 mt-2 mr-2 overflow-auto">
                        <vs-chip v-if="($store.getters['dash/currentUserLastAccessed'] < session.sessionStartTime || !$store.getters['dash/currentUserLastAccessed']) && !session.isSpam" color="primary">New</vs-chip>
                        <vs-chip v-if="session.isSpam" color="danger">Archived</vs-chip>
                      </div>                      
                      <div class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer spamtimespamhover hover:text-primary "><span class="feather-icon select-none relative">
                        <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" /></span>
                        <span v-if="!session.isSpam" class="text-sm font-semibold ml-2" @click.prevent="markAsSpam(session.sessionID)">Archive</span>
                        <span v-else class="text-sm font-semibold ml-2" @click.prevent="unmarkAsSpam(session.sessionID)">Restore</span>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </div>
            <vs-alert
      v-if="$store.state.dash.viewData.currentShowcasedIDs.length < 2"
      class="p-4 py-10 my-5 rounded-xl flex items-center text-dark"
      color="primary"
    >
    <div class="">

      <img src="@/assets/images/misc/showcase.png" class="mx-auto block h-32 mb-5"/>

      <p class="text-2xl mx-auto max-w-lg text-center font-semibold">
        Remember that you can "showcase" pieces of feedback or reviews to visitors on your website with Showcase Widgets.
      </p>

      <p class="my-6 text-lg">
        To do this, click on the "Showcase" button next to a piece of feedback or a review, and add that item for showcase.      
      </p>

      <p class="my-6 text-lg">
        You can also tag/label a showcase item for a specific purpose - for instance, you can have one widget showing items tagged as "Homepage" and one widget showing items tagged with "Blog". Simply hover over the downward arrow next to the "Showcase" button to tag/label an item.
      </p>
        
      <p class="mt-6 text-lg" v-if="!$store.getters['dash/isAgencyClientParentEID']">
        Once you've marked items for showcase you can install a showcase widget onto your site, by navigating to 'SHOWCASE' on the main menu, and then selecting 'Create Widget'.
      </p> 
    </div>               
    </vs-alert>  
            <p class="flex px-1 justify-between" v-if="!selectedQuestion && $store.state.dash.viewData.viewFeedback.length > 10 ">
              <span><span class="text-sm">showing </span>{{$store.getters['dash/collectionInfo'].count}} response{{$store.getters['dash/collectionInfo'].count === 1 ? '':'s'}}</span>
              <span><span class="text-sm hidden md:inline">Showing results between</span> {{formatDate(new Date($store.getters['dash/collectionInfo'].toTimeS * 1000))}} - {{formatDate(new Date($store.getters['dash/collectionInfo'].fromTimeS * 1000))}}</span>
            </p>
            <Pagination class="my-10" v-if="showPagination && $store.state.dash.viewData.viewFeedback.length > 10"/>
          </div>
          </div>
          <div v-else class="w-full">
            <NoFilteredResponses/>
          </div>
            </div>
          </div>
          </div>
          </div>
        </div>
    </div>
  </vs-tab>
  <vs-tab label="Google" @click="tabChange('gp')" v-if="$store.getters['dash/externalPlatforms'].gp" id="gp" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="gp" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
  <vs-tab label="Facebook" @click="tabChange('fb')" v-if="$store.getters['dash/externalPlatforms'].fb" id="fb" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="fb" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
  <vs-tab label="Trustpilot" @click="tabChange('tp')" v-if="$store.getters['dash/externalPlatforms'].tp" id="tp" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="tp" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
  <vs-tab label="TripAdvisor" @click="tabChange('ta')" v-if="$store.getters['dash/externalPlatforms'].ta" id="ta" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="ta" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
  <vs-tab label="Yelp" @click="tabChange('ye')" v-if="$store.getters['dash/externalPlatforms'].ye" id="ye" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="ye" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
  <vs-tab label="Foursquare" @click="tabChange('fs')" v-if="$store.getters['dash/externalPlatforms'].fs" id="fs" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="fs" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
  <vs-tab label="Capterra" @click="tabChange('ca')" v-if="$store.getters['dash/externalPlatforms'].ca" id="ca" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="ca" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
  <vs-tab label="G2" @click="tabChange('g2')" v-if="$store.getters['dash/externalPlatforms'].g2" id="g2" class="p-0">
    <div class="tab-text py-5 nofilterimags">
      <DisplayReviews platform="g2" @load-reviews="loadReviews"/>
    </div>
  </vs-tab>
</vs-tabs>
  </div>   








  <input type="file" style="display: none;" ref="ppInput" @change="editTestoFilesChange($event.target.files, 'pp')" accept="image/png, image/gif, image/jpeg">
  <input type="file" style="display: none;" ref="clInput" @change="editTestoFilesChange($event.target.files, 'cl')" accept="image/png, image/gif, image/jpeg">

  <vs-popup class="holamundo" title="Edit testimonial" :active.sync="showEditTesto" @close="closeEditTesto">           
        
        <div class="flex" v-if="currentEditTestoResponse">
                    
          <div class="flex-1">
          <label class="vs-input--label">Profile picture</label>          
          <div class="flex">
          <div  :style="{  backgroundColor: pmyColorLight,
                                borderColor: pmyColor,
                                color: pmyColor
                              }" class="pp empty" v-if="!currentEditTestoResponse.answer.profilePicture">
                                  <span>{{ getReviewerAcronym(currentEditTestoResponse.answer.name) }} </span>                                  
                              </div><div class="pp" v-else>
                                <img  :src="currentEditTestoResponse.answer.profilePicture"/>                                
                              </div>  
            <vs-button type="border" :disabled="uploadingPP" icon-pack="feather" :icon="uploadingPP ? '' : 'icon-upload'" @click="intentUploadPic('pp')">{{ uploadingPP ? 'Uploading...' : 'Select file'}}</vs-button>
            <vs-button icon="icon-trash" icon-pack="feather" type="flat" v-if="currentEditTestoResponse.answer.profilePicture" @click="() => {currentEditTestoResponse.answer.profilePicture = false}"></vs-button>            
          </div>
          <span v-if="uploadPPMessage" class="text-danger block mt-4">{{ uploadPPMessage }}</span>
          
          <label class="vs-input--label mt-4">Company logo</label>          
          <div>            
            <img v-if="currentEditTestoResponse.answer.companyLogo" :src="currentEditTestoResponse.answer.companyLogo" class="h-8 mb-2 block mr-2"/>
            <div class="flex">
              <vs-button type="border" :disabled="uploadingCL" icon-pack="feather" :icon="uploadingCL ? '' : 'icon-upload'"@click="intentUploadPic('cl')">{{ uploadingCL ? 'Uploading...' : 'Select file'}}</vs-button>
              <vs-button icon="icon-trash" icon-pack="feather" type="flat" v-if="currentEditTestoResponse.answer.companyLogo" @click="() => {currentEditTestoResponse.answer.companyLogo = false}"></vs-button>            
            </div>
            <span v-if="uploadCLMessage" class="text-danger block mt-4">{{ uploadCLMessage }}</span>
          </div>

          </div>


          <div class="flex-1">
            
            <vs-input class="mb-3" label="Company" v-validate="'max:40'" placeholder="Company name" name="Company" v-model="currentEditTestoResponse.answer.company"></vs-input>
            <span class="block my-2 text-danger" v-if="errors.first('Company')">{{ errors.first('Company')  }}</span>
            
            <vs-input label="Job title/Relationship" v-validate="'max:60'" name="Job title/relationship" placeholder="'Founder' or 'Customer'" v-model="currentEditTestoResponse.answer.jobTitle"></vs-input>
            <span class="block my-2 text-danger" v-if="errors.first('Job title/relationship')">{{ errors.first('Job title/relationship')  }}</span>
            
          </div>

        
        </div>
        
        
        <span class="text-danger block mt-4">{{ errors.first('Tag') }}</span>         
        <div class="con-vs-alert mt-1 con-vs-alert-success">
          <h4 class="titlex vs-alert--title">Why only specific values?</h4>
          <div class="vs-alert text-lg">
          <p>To preserve integrity and data privacy, we only allow editing of Profile Picture, Job title, Company and Company logo.</p>                  
        </div>
        </div>        
        <div class="overflow-auto mt-4">
          <vs-button class="float-right ml-1 px-32" @click="confirmUpdateTesto" :disabled="this.errors.any()">Update</vs-button>
          <vs-button type="border" class="float-right" @click="closeEditTesto">Cancel</vs-button>
        </div>        


  </vs-popup>


  </div>






















</template>

<script>


import showReviews from './components/ptcomponents/DisplayReviews.vue'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker';
import pSBC from 'shade-blend-color';
import 'vue2-datepicker/index.css';
import debounce from 'debounce'
import TimeAgo from 'javascript-time-ago'
import Showcase from './components/ptcomponents/Showcase.vue'
import en from 'javascript-time-ago/locale/en'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue';

import CSAT1 from './components/ptcomponents/svgs/csat0.vue'
import CSAT2 from './components/ptcomponents/svgs/csat1.vue'
import CSAT3 from './components/ptcomponents/svgs/csat2.vue'
import CSAT4 from './components/ptcomponents/svgs/csat3.vue'
import CSAT5 from './components/ptcomponents/svgs/csat4.vue'
import Star from './components/ptcomponents/svgs/star.vue'

import Pagination from './components/ptcomponents/Pagination.vue'
import NoFilteredResponses from './components/ptcomponents/NoFilteredResponses.vue'

import HLSVideoPlayer from './components/ptcomponents/hlsvideoplayer/HLSVideoPlayer.vue'

import { firebase } from '../firebase/firebaseConfig'

import {initFBShowcaseWdgts} from '../methods/fetchEntityData.js'
TimeAgo.locale(en)
const timeAgo = new TimeAgo('en-US')

const storageRef = firebase.storage().ref()

export default {
  components: {
    DatePicker,
    HLSVideoPlayer,
    'v-select': vSelect,
    'DisplayReviews': showReviews,
    Showcase,
    Pagination,
    NoFilteredResponses,
    CSAT1,
    CSAT2,
    CSAT3,
    CSAT4,
    CSAT5,
    Star,
    Pagesubtitle
    },
  mounted() {
    document.addEventListener('scroll', this.updateFilterScroll)
  },
  destroyed() {
    document.removeEventListener('scroll', this.updateFilterScroll)
  },
  data() {
    return {
      currentEditTestoResponse: false,
      showEditTesto: false,
      selectFromActive: false,
      uploadCLMessage: false,
      uploadPPMessage: false,      
      uploadingPP: false,
      uploadingCL: false,
      currentTab: 0,
      selectToActive: false,
      selectedFromDatePickerLocal: new Date(),
      selectedToDatePickerLocal: new Date(),
      clickNotClose: true,
      isFilterSidebarActive: true,
    }
  },
  computed: {
    pmyColor() {
      return this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex.hex
    },
    pmyColorLight()  {
      const cL = pSBC(0.95, this.pmyColor)
      return cL ? cL : '#FAFAFA'
    },
    currentShowcaseIDs() {
      return this.$store.state.dash.viewData.currentShowcasedIDs
    },
    windowWidth () { return this.$store.state.windowWidth },
    showPagination () {
      return !(this.showOnlyAnswers.length === 0 && this.selectedQuestion)
    },
    period: {
      get() {
        return [this.startTime, this.endTime]
      },
      set(v) {
        this.startTime = v[0]
        this.endTime = v[1]
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'periodWasChanged', value: true})
        this.filtersChangedUpdateDataset()
      }
    },
    startTime: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.startTime
      },
      set(v) {        
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'startTime', value: v})
      }
    },
    endTime: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.endTime
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'endTime', value: v})
      }
    },
    showPositive: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.showPositive
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'showPositive', value: v})
        this.delayFiltersChanged()
      }
    },
    showNeutral: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.showNeutral
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'showNeutral', value: v})
        this.delayFiltersChanged()
      }
    },
    showNegative: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.showNegative
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'showNegative', value: v})
        this.delayFiltersChanged()
      }
    },
    showNoRating: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.showNoRating
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'showNoRating', value: v})
        this.delayFiltersChanged()
      }
    },       
    showSpam: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.showSpam
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'showSpam', value: v})
        this.filtersChangedUpdateDataset()
      }
    },
    textFilter: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.text
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'text', value: v.replaceAll(' ','')})
        this.delayFiltersChanged()
      }
    },
    ///QUESTIONS
    selectedQuestion: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.questionID
      },
      set(v) {
        
        //reset showOnlyAnswers
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'showOnlyAnswers', value: []})

        if (v) {          
          this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'questionID', value: v})
        } else {                  
          this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'questionID', value: null})
        }

        this.filtersChangedUpdateDataset()              

      }
    },
    showOnlyAnswers: {
      get() {
        return this.$store.state.dash.viewState.viewResponseFilters.showOnlyAnswers
      },
      set(v) {
        this.$store.commit('dash/CHANGE_VIEW_FILTER', {filter: 'showOnlyAnswers', value: [...v]})
        this.delayFiltersChanged()
      }
    },
    currentSelectedQuestionData () {
      if (!this.selectedQuestion || !this.filterableQuestions) return false
      
      let toReturn
      this.filterableQuestions.forEach((q) => {
          if (q.questionID === this.selectedQuestion) toReturn = {...q}
        })
      return toReturn

    },
    filterableQuestions () {
      return this.$store.state.dash.viewData.questionsWithResponses
    },
    ///END QUESTIONS
    operationInProgress() {
      return this.$store.state.dash.showcaseOperationInProgress
    },
    windowWidth () { return this.$store.state.windowWidth },
    questionOptions () {
      return []
    },
    disabledStart () {
      return  {
        from: new Date(this.$store.state.dash.viewState.filters.view.startTime * 1000)
      }
    },
    disabledEnd () {
      return  {
        to: new Date(this.$store.state.dash.viewState.filters.view.endTime * 1000), // all dates up to
        from: new Date() // all dates from x going forward
      }
    }
  },
  watch: {
    windowWidth() {
      //noconsoleconsole.log('window changed')
      this.setSidebarWidth()
    }
  },  
  methods: {    
    downloadVideo(streamUID) {
      //this is available in the videos collection, but for now we can just assume it:
      window.open(`https://customer-n548bbvvl783tp8n.cloudflarestream.com/${streamUID}/downloads/default.mp4?filename=video_${streamUID.substr(0, 5)}.mp4`,'_blank')
    },
    validateLogo(file) {
      if (typeof file.size !== 'undefined') {
        if (file.size > 500000) {
          return {
            passed: false,
            reason: 'Your logo file may not be larger than 1MB in size.'
          }
        }
      }
      if (typeof file.size !== 'undefined') {
        if ((file.type !== 'image/png') && (file.type !== 'image/jpeg') && (file.type !== 'image/gif')) {
          return {
            passed: false,
            reason: 'Your logo file needs to be a JPG, GIF or PNG file extension.'
          }
        }
      }
      return {
        passed: true,
        reason: ''
      }
    },
    editTestoFilesChange(target, type) {
                  
      this.uploadCLMessage = false
      this.uploadPPMessage = false
      this.uploadingPP = false
      this.uploadingCL = false
      
      if (type === 'pp') {
        this.uploadingPP = true
      } else if (type === 'cl') {
        this.uploadingCL = true
      }

      if (typeof target[0] !== 'undefined') {

        let validation = this.validateLogo(target[0])
        let imgName = this.$store.state.signUpState.recorded.businessInfo.businessName + (new Date().getTime() / 1000)
        imgName = (imgName.replace(/[`~±!@#$%^&*()_|+\-=÷¿?;:'",.<> \{\}\[\]\\\/]/gi, '')).toLowerCase()
        imgName = imgName.replace(/[^\w\s]/gi, '')
        if (validation.passed) {

          let imageRef = storageRef.child(type === 'pp' ? 'dashPPuploads/' + imgName : 'dashCLuploads/' + imgName)
          
          this.uploadCLMessage = false
          this.uploadPPMessage = false
                                                  
          imageRef.put(target[0]).then((snapshot) => {
            snapshot.ref.getDownloadURL().then((dURL) => {                            
              if (type === 'pp') {
                this.currentEditTestoResponse.answer.profilePicture = dURL
                this.uploadingPP = false
              } else if (type === 'cl') {
                this.currentEditTestoResponse.answer.companyLogo = dURL
                this.uploadingCL = false
              }               

            }).catch((e) => {              
              if (type === 'pp') {
                 this.uploadingPP = false
                 this.uploadPPMessage = 'We couldn\'t upload your image, please ensure it\'s not larger than 500kb and either a JPEG, GIF or PNG file.'
              } else {
                this.uploadingCL = false
                this.uploadCLMessage = 'We couldn\'t upload your image, please ensure it\'s not larger than 500kb and either a JPEG, GIF or PNG file.'
              }              
            })
            
          }).catch((e) => {
            if (type === 'pp') {
                 this.uploadingPP = false
                 this.uploadPPMessage = 'We couldn\'t upload your image, please ensure it\'s not larger than 500kb and either a JPEG, GIF or PNG file.'
              } else {
                this.uploadingCL = false
                this.uploadCLMessage = 'We couldn\'t upload your image, please ensure it\'s not larger than 500kb and either a JPEG, GIF or PNG file.'
              }              
          })
        } else {
          if (type === 'pp') {
                 this.uploadingPP = false
                 this.uploadPPMessage = 'Image invalid, please ensure it\'s not larger than 500kb and either a JPEG, GIF or PNG file.'
              } else {
                this.uploadingCL = false
                this.uploadCLMessage = 'Image invalid, please ensure it\'s not larger than 500kb and either a JPEG, GIF or PNG file.'
              }              
        }

      }

    },
    intentUploadPic(type, sessionID, response) {

      //type == 'pp' or 'cl' for profile picture or company logo
      if (type === 'pp' && !this.currentEditTestoResponse) {
        this.intentEditTesto(sessionID, response)
      }

      console.log('intent upload pic')

      if (type === 'pp') {
        this.$refs.ppInput.click()
      } else if (type === 'cl') {
        this.$refs.clInput.click()
      }

    },
    intentEditTesto (sessionID, response) {      
      const newResponse = JSON.parse(JSON.stringify(response))
      
      newResponse.answer.companyLogo = typeof newResponse.answer.companyLogo !== 'undefined' ? newResponse.answer.companyLogo : false
      newResponse.answer.jobTitle = newResponse.answer.jobTitle ? newResponse.answer.jobTitle  : ''
      newResponse.answer.company = newResponse.answer.company ? newResponse.answer.company  : ''

      this.currentEditTestoResponse = { ...newResponse,  sessionID}
      this.showEditTesto = true

    },
    confirmUpdateTesto() {
          
      this.$vs.loading()

      this.$store.dispatch('dash/UPDATE_RESPONSE', {
        sessionID: this.currentEditTestoResponse.sessionID,
          jFI: this.currentEditTestoResponse.i,
          profilePicture: this.currentEditTestoResponse.answer.profilePicture,
          companyLogo: this.currentEditTestoResponse.answer.companyLogo,
          company: this.currentEditTestoResponse.answer.company.trim() === '' ? false : this.currentEditTestoResponse.answer.company.trim(),
          jobTitle: this.currentEditTestoResponse.answer.jobTitle.trim() === '' ? false : this.currentEditTestoResponse.answer.jobTitle.trim()
        }
      ).then(() => {
        this.$vs.notify({
          title: 'Update testimonial',
          text: 'Testimonial updated successfully',
          color: 'success',
          time: 8000,
          iconPack: 'feather',
          icon:'icon-check'})
          
          
          
          //check if current edited item was showcased:

          console.log(`${this.currentEditTestoResponse.sessionID}_${this.currentEditTestoResponse.i}`)
          if (this.currentShowcaseIDs.findIndex(e => e.id === `${this.currentEditTestoResponse.sessionID}_${this.currentEditTestoResponse.i}`) > -1) {            
            console.log('current item was showcased')
            const currentWidgets = this.$store.state.dash.viewData.currentWidgets.map((w) => w.widgetID)
            this.$store.dispatch('dash/BUILD_WIDGET', currentWidgets)            
          }
          
          
          this.closeEditTesto()

          



      }).catch(() => {
        this.$vs.notify({
          title: 'Update testimonial',
          text:'Oops! Something went wrong, and we couldn\'t update your testimonial. Please try again, and reach out for support if it happens again.',
          color: 'warning',
          time: 20000,
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      }).finally(() => {
        this.$vs.loading.close()
      })


    },
    closeEditTesto() {      
      this.currentEditTestoResponse = false
      this.uploadCLMessage = false
      this.uploadPPMessage = false
      this.uploadingPP = false
      this.uploadingCL = false
      this.showEditTesto = false
    },
    updateFilterScroll: debounce(function() {

      if (this.platform === 'feedback') {
  const filterEl = this.$refs.filters.$el
      
      const filterWrap = this.$refs.filterswrap

      if (this.windowWidth > 992) {        
        const offset = window.pageYOffset + filterWrap.getBoundingClientRect().top
        const scrollY = window.scrollY
        
        if (scrollY > 200) {
          if (scrollY < (offset - 60))  {
            filterEl.style.transform = `translateY(${scrollY}px)`
          } else {
            filterEl.style.transform = `translateY(${scrollY - 200}px)`
          }
        } else {
            filterEl.style.transform = `translateY(0px)`
        }        

      } else {
        filterEl.style.transform = 'none'
      } 
      }

         

    }, 20),
    delayFiltersChanged: debounce(function(){
        this.filtersChangedUpdateDataset()
      }, 1000),
    filtersChangedUpdateDataset () {
      if (!this.$store.state.dash.viewData.feedbackEmpty) {
        this.$store.dispatch('dash/QUERY_FEEDBACK', {isInitialFetch: false})
      }
    },
    refreshFeedback () {
      
      initFBShowcaseWdgts(false, true).then(() => {
        this.$vs.notify({
          title: 'Refresh feedback',
          text: 'Feedback up to date',
          color:'success',
          time: 4000,
          iconPack: 'feather',
          icon:'icon-check'})
      }).catch(() => {
        this.$vs.notify({
          title: 'Refresh feedback',
          text:'Oops! Something went wrong, and we couldn\'t refresh your feedback. Please try again, or please reach out for support if it happens again.',
          color:'warning',
          time: 7000,
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      })

    },
    actionShowcaseFeedback (pf, i, sessionID, tag, intent, currentTags) {
      this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', true)
      
      this.$store.dispatch('dash/TOGGLE_MARK_SHOWCASE', { platform: pf , i, sessionID, intent, tag, currentTags }).then((res) => {
        //noconsoleconsole.log('success')
        this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', false)
        this.$vs.notify({
          title: !intent ? 'Removed feedback from showcase'  : 'Added feedback for showcase',
          text: 'Please allow a few mins. for changes to reflect in your showcase widgets.',
          color:'success',
          time: 4000,
          iconPack: 'feather',
          icon:'icon-check'})
      }).catch((e) => {
        //noconsoleconsole.log('failure')
        console.log(e)
        this.$vs.notify({
          title:'Showcase feedback',
          time: 10000,
          text:'Oops! Something went wrong, and we couldn\'t add your feedback for showcase. Please try again, or please reach out for support if it happens again.',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
        this.$store.commit('dash/SHOWCASE_OPERATION_IN_PROGRESS', false)
        
        this.$store.commit('dash/MARK_SHOWCASE_ITEM', {
          jFI: i,
          rvwOrSnID: sessionID,
          type: pf,
          tag,
          intent: !intent
        })       

      })
    },
    getReviewerAcronym (name) {

      var names = name.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();
    
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;

    },  
    toggleShowcaseFeedback (pf, i, sessionID, tag, intent, currentTags) {

      //tag - false for none
      //intent - true for ADD, false for REMOVE

      /*
      Update for showcase should be synchronous, because the back-end op does work on array
      This setTimeout method should actually sit on the store, not here
      */
      //noconsoleconsole.log('toggling feedback')

      console.log(`new fb showcase with tg ${tag} and intent ${intent}`)
      
      this.$store.commit('dash/MARK_SHOWCASE_ITEM', {
        jFI: i,
        rvwOrSnID: sessionID,
        type: pf,
        tag,
        intent
      })

      const check = (pf, i, sessionID, tag, intent, currentTags) => {
        if (this.operationInProgress) {
          //noconsoleconsole.log('op in progress')
          setTimeout(() => {
            check(pf, i, sessionID, tag, intent, currentTags)
          }, 100)
        } else {
          //noconsoleconsole.log('op not in progress, actioning')
          this.actionShowcaseFeedback (pf, i, sessionID, tag, intent, currentTags)
        }
      }

      check(pf, i, sessionID, tag, intent, currentTags)

    },
    loadReviews (pf) {
        this.$store.dispatch('dash/LOAD_REVIEWS', { platform: pf })
    },
    tabChange (pf) {

      //noconsoleconsole.log(pf)
      
      if (this.$store.state.dash.viewData.reviews[pf].reviews.length === 0) {
        //noconsoleconsole.log('polling')
        this.$store.dispatch('dash/LOAD_REVIEWS', { platform: pf, notify: this.$vs.notify })
      }

    },
    unmarkAsSpam(sessionID, session) {

      this.$store.dispatch('dash/UNMARK_AS_SPAM', {
        sessionID: sessionID
      }).then(() => {

        //noconsoleconsole.log('UN MARKED AS SPAM')

      })
    },
    markAsSpam(sessionID, session) {

      //tell the view that we're marking as spa

      this.$store.dispatch('dash/MARK_AS_SPAM', {
        sessionID: sessionID
      }).then(() => {
        //send back an array here that gives the new sessions filtered?

        //noconsoleconsole.log('MARKED AS SPAM')
        //this.getSessionsToShow()

      })
    },
    renderContactDetailText(contact) {
          
      let returnString = ''
      returnString += ' ' + contact.name

      if (contact.email) {        
        returnString += ' | <a class="link" href="mailto:'
        returnString += contact.email
        returnString += '?subject=Response%20to%20your%20feedback&body='
        returnString += 'Hi%20' + contact.name.replace(' ', '%20') + ','
        returnString += '"'
        returnString += '>'
        returnString += contact.email
        returnString += '</a>'
      }       

      if (contact.mobile) {
        returnString += ` | <a href="tel:${contact.mobile}">${ contact.mobile }</a>`
      }

      if (contact.jobTitle) {
        returnString += ' | ' + contact.jobTitle        
      }

      if (contact.company) {
        returnString += ' | ' + contact.company
      }

      return returnString        

    },
    timeSince(date) {

      let dateObj = new Date(date * 1000)

      let hr = dateObj.getHours();
      let min = dateObj.getMinutes();
      if (min < 10) {
        min = "0" + min
      }
      let ampm = "AM"
      if (hr > 12) {
        hr -= 12;
        ampm = "PM"
      }

      let timeString = hr + ':' + min + ampm

      return {
        timeAgo: timeAgo.format(date * 1000, 'twitter'),
        timeOfDay: timeString
      }

    },
    changeSelectFrom () {
      this.$store.commit('dash/UPDATE_FROM_FILTER', {
        whichFilter: 'view',
        timeStampS: this.selectedFromDatePickerLocal.getTime() / 1000
      })
    },
    changeSelectTo () {
      this.$store.commit('dash/UPDATE_TO_FILTER', {
        whichFilter: 'view',
        timeStampS: this.selectedToDatePickerLocal.getTime() / 1000
      })
    },
    showSelectFrom () {
      //set the selected from date (local) to the current filter
      let currentFilterFrom = this.$store.state.dash.viewState.filters.view.startTime
      this.selectedFromDatePickerLocal = new Date(currentFilterFrom * 1000)
      this.selectFromActive = true
    },
    showSelectTo () {
      //set the selected to date (local) to the current filter
      let currentFilterTo = this.$store.state.dash.viewState.filters.view.endTime
      this.selectedToDatePickerLocal = new Date(currentFilterTo * 1000)
      this.selectToActive = true
    },
    formatDate (date) {
      let monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
      ]
      let day = date.getDate()
      let monthIndex = date.getMonth()
      let year = date.getFullYear()
      return day + ' ' + monthNames[monthIndex] + ' \'' + year.toString().substr(2,4)
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }
    },
    // GRID VIEW - ACTIONS
    toggleFilterSidebar() {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    }
  },
  created() {

    this.setSidebarWidth()

    if (typeof this.$route.query.platform !== 'undefined') {
      let index = 0
      let order = ['gp','fb','tp','ta','ye','fs','ca','g2']
      order.forEach((item, i) => {
        if (this.$store.getters['dash/externalPlatforms'][item] !== false) {
          index++
          if (item === this.$route.query.platform) {
            this.tabChange(this.$route.query.platform)
            this.currentTab = index
          }
        }
      });
    }

    if (typeof this.$route.params.questionid !== "undefined") {
      this.$store.commit('dash/SET_QUESTION_FILTER', this.$route.params.questionid)
    }

  }
}


/*

<h6 class="font-bold mb-2">Time Period</h6>

<div @click.prevent="showSelectFrom" >
  <vs-input class="pt_noopacity cursor-pointer" label="From" disabled="true" v-model="startTimeText" />
</div>
<vs-prompt
  title="Select From Date"
  :active.sync="selectFromActive"
  accept-text="Select"
  @accept="changeSelectFrom"
>
<datepicker class="mx-auto" placeholder="Select Date" :inline="true" v-model="selectedFromDatePickerLocal" style="z-index: 1000;" :disabled-dates="disabledStart"></datepicker>
</vs-prompt>
<div @click.prevent="showSelectTo" >
  <vs-input class="pt_noopacity cursor-pointer" label="To" disabled="true" v-model="endTimeText" />
</div>
<vs-prompt
  title="Select To Date"
  :active.sync="selectToActive"
  accept-text="Select"
  @accept="changeSelectTo"
  >
  <datepicker class="mx-auto" placeholder="Select Date" :inline="true" v-model="selectedToDatePickerLocal" style="z-index: 1000;" :disabled-dates="disabledEnd"></datepicker>
</vs-prompt>
<vs-divider/>

*/
</script>


<style lang="scss">


.ptlargerselect {
  font-size: 1.15rem;

  input {
    padding: 5px 7px !important;
  }

  ::placeholder {
    font-weight: 500 !important;
  }

  .vs__selected {

    padding: 5px 7px !important;
    display: inline-block;
  }
}



.vdp-datepicker__calendar {
  margin: 0 auto;
}

.minfilterh {
  min-height: 640px;
}

#algolia-instant-search-demo {
    .algolia-header {
        .algolia-filters-label {
            width: calc(260px + 2.4rem);
        }
    }

    #fb-content-container {

        .vs-sidebar {
            position: relative;
            float: left;
        }
    }

    .algolia-search-input-right-aligned-icon {
        padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
        min-width: unset;
    }

    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
        min-width: 50%;
    }

    .item-view-secondary-action-btn {
        min-width: 50%;
    }
}

.theme-dark {
    #algolia-instant-search-demo {
        #fb-content-container {
            .vs-sidebar {
                background-color: #10163a;
            }
        }
    }
}

@media (min-width: 992px) {
    .vs-sidebar-rounded {
        .vs-sidebar {
            border-radius: 0.5rem;
        }

        .vs-sidebar--items {
            border-radius: 0.5rem;
        }
    }
}

@media (max-width: 992px) {
    #fb-content-container {
        .vs-sidebar {
            position: absolute !important;
            float: none !important;
        }
    }
}

.vs-sidebar-rounded.dsabled {
  position: relative;
  &::after {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: block;
    content: "";
    z-index: 1000;
    position: absolute;
    border-radius: inherit;
    top: 0;
    left: 0;
  }
}


  button#gp {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fgp.png?alt=media&token=7259247a-c8f4-49c6-9273-7898c3fc4a32');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  button#list {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Flist.png?alt=media&token=8094f9f9-e3c3-4cce-a004-ceb4b57c60f7');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 55%;
      transform: translateY(-50%);
    }
  }

  button#fb {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ffb.png?alt=media&token=5dde0255-6681-4041-95e4-d6cbbfd48ddf');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 52%;
      transform: translateY(-50%);
    }
  }

  button#ca {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fct.png?alt=media&token=eaf0e9aa-c3fd-49df-91d8-f252cf0f2b6b');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 52%;
      transform: translateY(-50%);
    }
  }

  button#fs {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ffs.png?alt=media&token=936ef53c-adfa-4f4d-b7ed-ed65f16b0043');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 52%;
      transform: translateY(-50%);
    }
  }

  button#g2 {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fgc.png?alt=media&token=84f53ef2-6e10-4fbf-b5ab-1da8e2f33aaf');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 52%;
      transform: translateY(-50%);
    }
  }

  button#ta {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fta.png?alt=media&token=0c7688cd-c97b-40bf-a398-574485a5a571');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 52%;
      transform: translateY(-50%);
    }
  }

  button#tp {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ftp.png?alt=media&token=a2ab4a17-1c10-4edf-82a0-163385d31a35');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 52%;
      transform: translateY(-50%);
    }
  }

  button#ye {
    &:before {
      background: url('https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fye.png?alt=media&token=5e8a6823-8d78-43b5-b49c-907cf6417192');
      content: "";
      background-repeat: no-repeat;
      background-size: contain;
      z-index: 100;
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 8px;
      top: 52%;
      transform: translateY(-50%);
    }
  }

  .shadow-transition {
    transition: text-shadow 0.2s ease-in;
  }

  .showshadow {
    text-shadow: rgba(167, 9, 213, 1) 1px 0 20px;
  }

  //lst https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Flist.png?alt=media&token=8094f9f9-e3c3-4cce-a004-ceb4b57c60f7
  //gp https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fgp.png?alt=media&token=7259247a-c8f4-49c6-9273-7898c3fc4a32
  //ct https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fct.png?alt=media&token=eaf0e9aa-c3fd-49df-91d8-f252cf0f2b6b
  //fb https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ffb.png?alt=media&token=5dde0255-6681-4041-95e4-d6cbbfd48ddf
  //fs https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ffs.png?alt=media&token=936ef53c-adfa-4f4d-b7ed-ed65f16b0043
  //g2 https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fgc.png?alt=media&token=84f53ef2-6e10-4fbf-b5ab-1da8e2f33aaf
  //ta https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fta.png?alt=media&token=0c7688cd-c97b-40bf-a398-574485a5a571
  //tp https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ftp.png?alt=media&token=a2ab4a17-1c10-4edf-82a0-163385d31a35
  //ye https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fye.png?alt=media&token=5e8a6823-8d78-43b5-b49c-907cf6417192
  .af {
    button.vs-tabs--btn {
      font-size: 1.18rem !important;
      font-weight: 400;
      padding-left: 30px;
      margin: 0 0.2rem;
      position: relative;
    }
  }

  .starratingwrap {
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .vfbstar {
      position: absolute;  
      top: 50%;
      left: 50%;    
      transform: translate(-50%, -56%);      
    }
  }

.text-danger {
 svg {
    path,circle {
        fill: #EA5455;
    }

  }
}

.text-warning {
 svg {
    path,circle {
        fill:#FF9F43;
      }
  }
}

.text-success{
  svg {
    path,circle {
      fill: #28C76F;
      }
  }
 }  


.sessionsidepanel {
  border-left: 1px solid #e9e9e9;
}



//testimonial
.bggray {
  background-color: #f9f9f9;
}

.testo {
  padding: 2%;
  border-radius: 7px;  
  background-color: #f5f5f5;
  box-shadow: 0 0 3px rgba(0,0,0,0.1);
}

.video {
  > div {
    .vjs-control-bar {
      border-radius: 0 0 10px 10px;
    }
    .video-js {
      border-radius: 10px !important;
      video {
        border-radius: 10px !important;
      }
    }
  }
}

.testinfo {
  
  display: flex;
  align-content: center;
  justify-content: start;
  align-items: center;
  

}

.pp {
    
    cursor: pointer;
    margin-right: 0.5rem;
    border-radius: 100px;
    width: 40px;
    height: 40px;
    background: white;
    display: flex;
    overflow: hidden;
    align-content: center;
    justify-content: center;
    align-items: center;
    position: relative;
    
    img {
      width: 100%;
      display: block;
    }
    
    &.empty {        
        border-radius: 50px;
        font-size: 0.9rem;
        border: 1px solid #CECECE;
        span {

        }
    }

    .changePP {
      visibility: hidden;
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.5);
      display: flex;
      justify-content: center;
    }

    &:hover {
      .changePP {
        visibility: visible;
      }
    }



  }

.testtxt {
  margin-top: 2rem;
}





</style>
